import { createSelector } from "reselect";

import {
  isGeographyBoundaryLegend,
  isNothingBoundaryLegend,
  isTerritoryBoundaryLegend,
  isTerritoryColorBoundaryLegend,
} from "@mapmycustomers/shared/util/boundaryLegends";

import { RootState } from "@app/store/rootReducer";

const boundaryLegendsState = (state: RootState) => state.boundaryLegends;

export const getAllBoundaryLegends = createSelector(boundaryLegendsState, ({ legends }) => legends);

export const getTerritoryBoundaryLegends = createSelector(getAllBoundaryLegends, (legends) =>
  legends.filter(isTerritoryBoundaryLegend)
);

export const getGeographyBoundaryLegends = createSelector(getAllBoundaryLegends, (legends) =>
  legends.filter(isGeographyBoundaryLegend)
);

export const getDefaultTerritoryLegend = createSelector(getAllBoundaryLegends, (legends) =>
  legends.find(isTerritoryColorBoundaryLegend)
);

export const getDefaultGeographyLegend = createSelector(getAllBoundaryLegends, (legends) =>
  legends.find(isNothingBoundaryLegend)
);

export const isCreating = createSelector(boundaryLegendsState, ({ creating }) => creating);
export const isDeleting = createSelector(boundaryLegendsState, ({ deleting }) => deleting);
export const isUpdating = createSelector(boundaryLegendsState, ({ updating }) => updating);
